import React, { useEffect, useState } from "react";
import { getContent } from "@/lib/api";
import { Megaphone, X } from "@phosphor-icons/react";

export function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    getContent("announcements")
      .then((list) => {
        const active = (list || []).filter((a) => a.active);
        if (!active.length) return;
        const dismissed = JSON.parse(localStorage.getItem("qs_dismissed_ann") || "[]");
        const next = active.find((a) => !dismissed.includes(a.id));
        if (next) setAnn(next);
      })
      .catch(() => {});
  }, []);

  if (!ann) return null;

  const dismiss = () => {
    const dismissed = JSON.parse(localStorage.getItem("qs_dismissed_ann") || "[]");
    localStorage.setItem("qs_dismissed_ann", JSON.stringify([...dismissed, ann.id]));
    setAnn(null);
  };

  return (
    <div
      data-testid="announcement-banner"
      className="relative z-[55] border-b border-[#2DD4BF]/20 bg-gradient-to-r from-[#2DD4BF]/10 via-[#0E9E90]/10 to-transparent"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-2.5 flex items-center gap-3">
        <Megaphone size={16} className="text-[#2DD4BF] shrink-0" weight="fill" />
        <p className="flex-1 text-xs sm:text-sm text-[#cbd5e1] truncate">
          <span className="font-semibold text-white">{ann.title}</span>
          {ann.body && <span className="hidden sm:inline"> — {ann.body}</span>}
        </p>
        <button
          onClick={dismiss}
          data-testid="announcement-dismiss"
          className="shrink-0 grid place-items-center h-6 w-6 rounded-md text-[#94A3B8] hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Dismiss announcement"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
